import { getTenantCreationRequest } from '@/lib/api-client';
import { useQuery } from '@tanstack/react-query';
import { createContext, PropsWithChildren, useContext } from 'react';
import * as dtos from '@/lib/dtos';
import { Navigate, useParams } from 'react-router';

const TenantCreationRequestContext =
  createContext<dtos.TenantCreationRequest | null>(null);

export function useTenantCreationRequest(): dtos.TenantCreationRequest {
  const context = useContext(TenantCreationRequestContext);

  if (context === null) {
    throw new Error();
  }

  return context;
}

export function useTenantCreationRequestQuery(slug: string | null) {
  return useQuery<dtos.TenantCreationRequest | null>({
    queryKey: ['tenant-creation-requests', slug],
    queryFn: async () => {
      const tenantcreationrequest = await getTenantCreationRequest(slug ?? '');
      return tenantcreationrequest;
    },
    enabled: slug !== null,
  });
}

export function TenantCreationRequestProvider({ children }: PropsWithChildren) {
  const slug = useParams().tenantCreationRequestSlug;
  const { data } = useTenantCreationRequestQuery(slug ?? null);

  if (!slug) {
    console.warn(`route param :tenantCreationRequestSlug is null`);
  }

  if (data === undefined) {
    return <div></div>;
  }

  if (data === null) {
    return <Navigate to="/" />;
  }

  return (
    <TenantCreationRequestContext.Provider value={data}>
      {children}
    </TenantCreationRequestContext.Provider>
  );
}
